// LandlineInput.jsx
import React from 'react';
import { TextField, InputAdornment, FormControl } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Error } from '@mui/icons-material';

const LandlineInput = ({ value, onChange, error, type, ...props }) => {
    const theme = useTheme();

    const handleChange = (e) => {
        const cleanedValue = e.target.value
            .replace(/[^0-9+()-]/g, '') // السماح بالأرقام وبعض الرموز
            .slice(0, 15); // تحديد الطول الأقصى

        onChange({
            ...e,
            target: {
                ...e.target,
                value: cleanedValue
            }
        });
    };

    return (
        <FormControl fullWidth variant="outlined" sx={{ backgroundColor: theme.palette.background.input }}>

            <TextField
                {...props}
                type="tel"
                value={value}
                onChange={handleChange}
                required
                error={!!error}
                // sx={{
                //     backgroundColor: theme.palette.background.input,
                //     borderRadius: 1,
                //     '& .MuiOutlinedInput-input': {
                //         padding: '12px 14px',
                //     }
                // }}
                sx={{
                    '& .MuiOutlinedInput-input': {
                        paddingLeft: 2,
                        // textAlign: lng === 'ar' ? 'right' : 'left',
                        height: '10px',
                        '&::placeholder': {
                            textAlign: 'left',
                        },
                    },
                    '& .MuiOutlinedInput-root': {
                        // flexDirection: lng === 'ar' ? 'row-reverse' : 'row',
                    },
                    '& .MuiInputAdornment-root': {
                        // flexDirection: lng === 'ar' ? 'row-reverse' : 'row',
                    }
                }}
                inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                }}
                label=""
                name={type}
                InputProps={{
                    inputProps: {
                        pattern: (/[+0-9() -]*/),
                    },
                    endAdornment: error && (
                        <InputAdornment position="end">
                            <Error color="error" />
                        </InputAdornment>
                    ),
                }}
            />
        </FormControl>
    );
};

export default LandlineInput;